export function modalwindow() {
  const modal = document.querySelector(".modalElement");
  if (modal) {
    const openModalBtns = document.querySelectorAll(".openModalButton");
    const spinner = document.querySelector(".loading-spinner");
    if (openModalBtns.length > 0) {
      openModalBtns.forEach((elem) => {
        elem.addEventListener("click", () => {
          modal.classList.toggle("open");
        });
      });
    }

    document.querySelector(".close").addEventListener("click", () => {
      modal.classList.toggle("open");
      const onCloseEvent = new Event("ocwModalClosed");
      document.querySelector("#first_name").value = "";
      document.querySelector("#last_name").value = "";
      document.querySelector("#phone_number").value = "";
      document.querySelector("#zip_code").value = "";
      modal.dispatchEvent(onCloseEvent);
    });

    document.querySelector("#zip_code").addEventListener("input", (e) => {
      let currVal = e.currentTarget.value.replace(/\D/g, "");
      e.currentTarget.value = currVal;
      const debounceDelay = 200; // a small delay waiting for the user to stop typing the zipcode;
      const stateSelect = document.querySelector("#state");
      if (stateSelect) {
        if (e.target.value.length === 5) {
          let debounceTimer; 
          debounceTimer = setTimeout(() => {
            fetchStateCode(currVal,stateSelect); // call the API
          }, debounceDelay);
        }
      }
    });
    /* I'm commenting this section because will be needed for future spiints */

    document.querySelector("#zip_code").addEventListener("change", (e) => {
      let postalCode = e.currentTarget.value;
      const stateSelect = document.querySelector("#state");
      if (postalCode.length >= 5) {
        if (document.querySelector("#state")) {
          const debounceDelay = 200; // a small delay waiting for the user to stop typing the zipcode;
          let debounceTimer; 
          debounceTimer = setTimeout(() => {
            fetchStateCode(postalCode,stateSelect); // call the API
          }, debounceDelay);
        }
      }
    });

    document.querySelector("#phone_number").addEventListener("input", (e) => {
      let currVal = e.currentTarget.value.replace(/\D/g, "");
      if (currVal.length <= 3) {
        e.currentTarget.value = currVal;
      } else if (currVal.length <= 6) {
        e.currentTarget.value = currVal.slice(0, 3) + "-" + currVal.slice(3);
      } else {
        e.currentTarget.value =
          currVal.slice(0, 3) +
          "-" +
          currVal.slice(3, 6) +
          "-" +
          currVal.slice(6, 10);
      }
    });

    document
      .querySelector(".submit-modal")
      .addEventListener("click", (event) => {
        event.preventDefault();
        if(spinner){
          spinner.style.display = 'flex';
        }
        document.querySelector(".submit-modal").setAttribute("disabled", "");
        let firstName = document.querySelector("#first_name").value.trim();
        let lastName = document.querySelector("#last_name").value.trim();
        const phoneNumber = document
          .querySelector("#phone_number")
          .value.trim();
        const postCode = document.querySelector("#zip_code").value.trim();
        const stateCode = document.querySelector("#state").value.trim();
        
        const phoneRegex = /^\(?[2-9]\d\d\)?[\s-]?([2-9](?!11)[0-9]{2})[\s-]?([0-9]{4})/;
        let regex = /^[a-zA-ZáéíóúÁÉÍÓÚüÜñÑ ]+$/;
        let zipCodePattern = /^\d{5}(-\d{4})?$/;
        const preferredLanguage = document.querySelector(
          'input[name="preferredLanguage"]:checked'
        );

        if (!firstName || !regex.test(firstName)) {
          document.querySelector(".input-error.first_name").style.display =
            "block";
          document.querySelector(".submit-modal").removeAttribute("disabled");
          setTimeout(() => {
            document.querySelector(".input-error.first_name").style.display =
              "none";
          }, 3500);
          if(spinner){
            spinner.style.display = 'none';
          }
          return false;
        }

        if (!lastName || !regex.test(lastName)) {
          document.querySelector(".input-error.last_name").style.display =
            "block";
          document.querySelector(".submit-modal").removeAttribute("disabled");
          setTimeout(() => {
            document.querySelector(".input-error.last_name").style.display =
              "none";
          }, 3500);
          if(spinner){
            spinner.style.display = 'none';
          }
          return false;
        }

        if (!stateCode) {
          console.log("");
          document.querySelector(".input-error.state").style.display = "block";
          document.querySelector(".submit-modal").removeAttribute("disabled");
          setTimeout(() => {
            document.querySelector(".input-error.state").style.display = "none";
          }, 3500);
          if(spinner){
            spinner.style.display = 'none';
          }
          return false;
        }
        if (!postCode || !zipCodePattern.test(postCode)) {
          document.querySelector(".input-error.zip_code").style.display =
            "block";
          document.querySelector(".submit-modal").removeAttribute("disabled");
          setTimeout(() => {
            document.querySelector(".input-error.zip_code").style.display =
              "none";
          }, 3500);
          if(spinner){
            spinner.style.display = 'none';
          }
          return false;
        }
        
        if (!phoneNumber || !phoneRegex.test(phoneNumber)) {
          document.querySelector(".input-error.phone_number").style.display =
            "block";
          document.querySelector(".submit-modal").removeAttribute("disabled");
          setTimeout(() => {
            document.querySelector(".input-error.phone_number").style.display =
              "none";
          }, 3500);
          if(spinner){
            spinner.style.display = 'none';
          }
          return false;
        }

        if (!preferredLanguage) {
          document.querySelector(
            ".input-error.preferredLanguage"
          ).style.display = "block";
          document.querySelector(".submit-modal").removeAttribute("disabled");
          setTimeout(() => {
            document.querySelector(
              ".input-error.preferredLanguage"
            ).style.display = "none";
          }, 3500);
          if(spinner){
            spinner.style.display = 'none';
          }
          return false;
        }

        const data = JSON.stringify({
          firstName: firstName,
          lastName: lastName,
          phoneNumber: phoneNumber,
          preferredLanguage: preferredLanguage.value,
          partnerName: "WESTERN_UNION",
          postalCode: postCode,
          state: stateCode,
        });
        const url =
          window.location.origin == "https://oportun.com"
            ? "https://apply.oportun.com/api/mobile/v3/request-callback"
            : "https://online-origination.1.app.stage.pfops.com/api/mobile/v3/request-callback";

        fetch(url, {
          method: "POST",
          headers: {
            "Content-type": "application/json",
          },
          body: data,
        })
          .then((response) => {
            if (response.status === 200) {
              console.log("we got 200");
            } else {
              throw new Error(`Error: ${response.status}`);
            }
          })
          .then((data) => {
            document.querySelector(".submit-modal").removeAttribute("disabled");
            document.querySelector(".modal-success-msg").style.display = "flex";
            setTimeout(() => {
              document.querySelector(".modal-success-msg").style.display =
                "none";
            }, 5000);
            modal.classList.remove("open");
            document.querySelector("#first_name").value = "";
            document.querySelector("#last_name").value = "";
            document.querySelector("#phone_number").value = "";
            document.querySelector(
              'input[name="preferredLanguage"]:checked'
            ).checked = false;
            if(spinner){
              spinner.style.display = 'none';
            }
          })
          .catch((error) => {
            document.querySelector(".submit-modal").removeAttribute("disabled");
            document.querySelector(".modal-error-msg").style.display = "flex";
            if(spinner){
              spinner.style.display = 'none';
            }
            setTimeout(() => {
              document.querySelector(".modal-error-msg").style.display = "none";
            }, 5000);
            console.error("Error:", error);
          });
      });

    document.addEventListener("ocwModalClosed", () => {
      const inputs = modal.querySelectorAll("input");
      console.log(inputs);
    });
  }
}

async function fetchStateCode(zipCode,stateDropDownElem) {
  const spinner = document.querySelector(".loading-spinner");
  if(spinner){
    spinner.style.display = 'flex';
  }
  const urlZipStateAPI =
            window.location.origin == "https://oportun.com"
              ? "https://apply.oportun.com/api/mobile/serviciable/zipcodeLookup"
              : "https://online-origination.1.app.stage.pfops.com/api/mobile/v3/serviceable/zipcode-lookup";
	stateDropDownElem.disabled = true;
	fetch(`${urlZipStateAPI}/${zipCode}`, {
    method: "GET",
    headers: {
      "Content-type": "application/json",
    },
  })
  .then((response) => response.json())
  .then((data) => {
    stateDropDownElem.disabled = false;
    if (data.populateAddress) {
      const state = data.populateAddress.state;

      console.log("state:", state); //
      const option = Array.from(stateDropDownElem.options).find(
        (option) => option.value == state
      );

      if (option) {
        stateDropDownElem.value = state;
      } else {
        stateDropDownElem.value = ""; 
      }
      if(spinner){
        spinner.style.display = 'none';
      }
    }
  })
  .catch((error) => {
    if(spinner){
      spinner.style.display = 'none';
    }
    stateDropDownElem.disabled = false;
    console.error("Error al obtener el estado:", error);
  });
}